import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SDLC_STAGES } from './stages';
import { SDLC_STAGE_COMPONENT_IDS } from '../../constants/componentAccess';
import { getCachedDecodedToken, hasComponentAccess } from '../../services/auth.service';
import './SDLCNavigation.css';

/**
 * Top-level horizontal tab strip for the SDLC workspace. Renders one button
 * per stage defined in `stages.js`, filtered to the stages the current user
 * has framework-component access to.
 */
function SDLCNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const tokenData = getCachedDecodedToken();

  const visibleStages = SDLC_STAGES.filter((s) => {
    const componentId = SDLC_STAGE_COMPONENT_IDS[s.id];
    if (!componentId) return true;
    return hasComponentAccess(tokenData, componentId);
  });

  const activeStage = (() => {
    const m = location.pathname.match(/^\/tools\/sdlc\/([^/]+)/);
    return m ? m[1] : null;
  })();

  if (visibleStages.length === 0) {
    return null;
  }

  return (
    <nav className="sdlc-nav" aria-label="SDLC stages">
      {visibleStages.map((stage) => (
        <button
          key={stage.id}
          type="button"
          className={`sdlc-nav-btn ${activeStage === stage.id ? 'active' : ''}`}
          onClick={() => navigate(`/tools/sdlc/${stage.id}`)}
          title={stage.description}
        >
          <span className="sdlc-nav-icon" aria-hidden="true">{stage.icon}</span>
          <span>{stage.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default SDLCNavigation;
